var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('v-chip',{attrs:{"role":"matrix-status-badge","color":_vm.matrixStatusColor,"x-small":""}},[_vm._v(_vm._s(_vm.displayedIndex))]),(_vm.hasCriticalError)?_c('v-icon',{attrs:{"color":_vm.matrixStatusColor}},[_vm._v("mdi-alert")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }